import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function MyCalendar({
    lable = "Select Date",
    name,
    value,
    onChange,
    error,
    disabled,
    excludeDates = [],
}) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return (
        <div className="w-full">
            <label className="block text-sm mb-1">
                {lable}
            </label>

            <DatePicker
                selected={value ? new Date(value) : null}
                onChange={(date) =>
                    onChange({
                        target: {
                            name,
                            value: date,
                        },
                    })
                }
                minDate={today}
                excludeDates={excludeDates.map(
                    (date) => new Date(date)
                )}
                disabled={disabled}
                wrapperClassName="w-full"
                className={`
                    input
                    input-bordered
                    input-md
                    w-full
                    ${error
                        ? "border-red-500 focus:border-red-500 focus:outline-red-500"
                        : ""
                    }
                `}
            />
        </div>
    );
}

export default MyCalendar;